import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function Mobile() {
  const face = FACE_BY_ID.mobile;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Android"
      titulo="Android nativo, publicado e mantido depois."
      intro="Engenheiro mobile sênior na Tonic3, divisão de experiência da W3, em Dallas. Kotlin com Jetpack Compose no que é novo, Java no que já roda há anos e não pode parar — inclusive a parte chata: build assinada, faixa de teste, revisão da loja e triagem de travamento."
      entrego={[
        {
          titulo: "Aplicativo do zero",
          corpo: "Kotlin, Compose e Material 3, com banco local e trabalho em segundo plano desde o começo.",
        },
        {
          titulo: "Modernização sem parar a casa",
          corpo: "Migração de Java e XML para Compose por partes, com o aplicativo publicando normalmente no meio do caminho.",
        },
        {
          titulo: "Operação de loja",
          corpo: "Trilha de lançamento, teste interno, Play Console e triagem de travamento e de tela congelada.",
        },
        {
          titulo: "Motor dentro do app",
          corpo: "Tela renderizada em Unity dentro de um aplicativo nativo, sem o usuário perceber a emenda.",
        },
      ]}
      publicado={[
        {
          titulo: "Guia Guiné",
          marca: "Play Store",
          corpo: "Aplicativo de guia publicado na Google Play, lançamento independente do JGson.",
          link: "https://play.google.com/store/apps/details?id=com.jgson.guiaguine",
        },
      ]}
      nota="A maior parte do Android nativo que eu entrego sai sob contrato de confidencialidade, pela Tonic3, então não aparece numa lista pública. Numa conversa eu explico as decisões técnicas de cada um."
    />
  );
}
